import { SET_BRAND } from "../../../constants/action-types/brand";

export const setBrand = (brand) => ({
  type: SET_BRAND,
  payload: brand,
});